import React from 'react';

interface DebugPageDataProps {
    title: string | null;
    templateName: string | null;
    pageTemplate: string | null;
    jsonData: string;
}

const DebugPageData: React.FC<DebugPageDataProps> = ({ title, templateName, pageTemplate, jsonData }) => {

    if (process.env.GATSBY_SHOW_DEBUG_DATA !== 'true') return null;

    const data = JSON.parse(jsonData);

    return (
        <div className="pattern pattern--standard-content">
            <div className="container container--md">
                <div className="rtecontent">
                    <h1>This is the {title} page</h1>

                    {pageTemplate && <p>Page Template: {pageTemplate}</p>}

                    {templateName && <p>Here's the data we're currently querying for a {templateName}:</p>}
                    {!templateName && <p>Here's the data we're currently querying:</p>}
                    <pre>{JSON.stringify(data, null, 2)}</pre>

                </div>
            </div>
        </div>
    );
};

export default DebugPageData;